import React, { useState, useEffect } from "react";
import BasicTable from "../../Components/BasicTable/BasicTable";
import { useCurrentUser } from "../../hooks/useAuth";
import { useEventByRole } from "../../hooks/useEvent";

export default function Dashboard() {
  const currentUser = useCurrentUser();
  const [selectedDateFilter, setSelectedDateFilter] = useState("This Day");
  const [WeeksInfo, setWeeksInfo] = useState([
    {
      icon: "fa-solid fa-calendar-day",
      times: 0,
      calendar: "Today",
      color: "#EC9A1E",
    },
    {
      icon: "fa-solid fa-calendar-week",
      times: 0,
      calendar: "Week",
      color: "#952264",
    },
    {
      icon: "fa-solid fa-calendar",
      times: 0,
      calendar: "Month",
      color: "#159bd7",
    },
  ]);

  // Get today's date range
  const today = new Date();
  const startOfDay = new Date(today.setHours(0, 0, 0, 0));
  const endOfDay = new Date(today.setHours(23, 59, 59, 999));

  // Get current week's date range
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay());
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);

  // Get current month's date range
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const { data: todayEvents } = useEventByRole({
    user: currentUser,
    dateRange: { from: startOfDay, to: endOfDay },
    enabled: !!currentUser
  });

  const { data: weekEvents } = useEventByRole({
    user: currentUser,
    dateRange: { from: startOfWeek, to: endOfWeek },
    enabled: !!currentUser
  });

  const { data: monthEvents } = useEventByRole({
    user: currentUser,
    dateRange: { from: startOfMonth, to: endOfMonth },
    enabled: !!currentUser
  });

  useEffect(() => {
    if (todayEvents && weekEvents && monthEvents) {
      setWeeksInfo([
        {
          icon: "fa-solid fa-calendar-day",
          times: todayEvents.length,
          calendar: "Today",
          color: "#EC9A1E",
        },
        {
          icon: "fa-solid fa-calendar-week",
          times: weekEvents.length,
          calendar: "Week",
          color: "#952264",
        },
        {
          icon: "fa-solid fa-calendar",
          times: monthEvents.length,
          calendar: "Month",
          color: "#159bd7",
        },
      ]);
    }
  }, [todayEvents, weekEvents, monthEvents]);

  const getFilteredEvents = () => {
    switch (selectedDateFilter) {
      case "This Day":
        return todayEvents || [];
      case "This Week":
        return weekEvents || [];
      case "This Month":
        return monthEvents || [];
      default:
        return todayEvents || [];
    }
  };

  const handleDateFilterChange = (filter) => {
    setSelectedDateFilter(filter);
  };

  return (
    <div className="container d-flex flex-column gap-4 align-items-start">
      <div className="container-fluid container-md">
        <div className="flex justify-between">
          <h2 className="my-3 text-2xl font-semibold">
            Hi, {currentUser?.first_name}
          </h2>
        </div>
        <div className="flex justify-between items-center w-full">
          <div className="flex flex-col gap-4 items-start w-full">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
              {WeeksInfo.map((item, index) => (
                <div
                  key={index}
                  style={{ backgroundColor: item.color }}
                  className="flex flex-col items-center justify-center p-6 rounded-lg shadow-md text-white transition-transform hover:scale-105"
                >
                  <div className="mb-2">
                    <i className={`${item.icon} text-4xl`}></i>
                  </div>
                  <div className="text-center flex items-center gap-2">
                    <span className="text-xl font-bold">{item.times}</span>
                    <span>{item.calendar}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="w-full bg-white rounded-lg shadow-lg p-4">
              <BasicTable 
                events={getFilteredEvents()} 
                selectedDateFilter={selectedDateFilter}
                onDateFilterChange={handleDateFilterChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}